import React from 'react'
import { Box } from '@mui/material'
import { usePostExportDealerMysteryShopper } from '../../../../api/promotions/dealer/dealer-mystery-shopper'
import SearchParam from '../../../shared/SearchParam'
import ExportButton from '../../../shared/ExportButton'
import ImportButton from './ImportButton'

const Toolbar = () => {
  const exportApi = usePostExportDealerMysteryShopper()

  return (
    <Box display='flex' justifyContent='space-between' alignItems='center' m={1} gap={4}>
      <SearchParam param='businessName' placeholder='Search by business name...' />
      <Box display='flex' gap={1}>
        <ImportButton />
        <ExportButton exportApi={exportApi} fileLabel={'promotions_dealer_mystery_shopper'} />
      </Box>
    </Box>
  )
}

export default Toolbar
